"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocus = void 0;
var _react = require("react");
var useFocus = exports.useFocus = function useFocus() {
  var htmlElRef = (0, _react.useRef)();
  var setFocus = function setFocus() {
    htmlElRef.current && htmlElRef.current.focus();
  };
  return [htmlElRef, setFocus];
};